export default __webpack_public_path__ + "static/186-62ab2acd69c5cc75b9f9dcf1877babca.gif";